<template>
  <div class="text-center">
    <span :class="`big-number ${item.class ? item.class : ''}`">
      {{ item.number }}
    </span>
    <br>
    <small>{{ item.title }}</small>
  </div>
</template>

<script>
  export default {
    name: 'BigNumbersComponent',
    props: {
      item: {
        type: Object,
        default: null,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .big-number {
    font-size: 1.8rem;
    font-weight: bold;
    color: $dark-grey;
  }

  small {
    color: $grey;
  }
</style>
